import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute } from '@angular/router';
import { UsersFacade } from '@app/shared/+state/users';
import { EntitlementEnum } from '@app/shared/interfaces';
import { Observable } from 'rxjs';
import { BillingFacade } from '../../../../shared/+state/billing/billing.facade';
import { DialogDirectCancelInterstitialComponent } from '../../dialogs/dialog-direct-cancel-interstitial/dialog-direct-cancel-interstitial.component';
import { DialogSubscribeToDirectComponent } from '../../dialogs/dialog-subscribe-to-direct/dialog-subscribe-to-direct.component';
import { DialogSwitchPlanInterstitialComponent } from '../../dialogs/dialog-switch-plan-interstitial/dialog-switch-plan-interstitial.component';
import { DirectPlan, DirectSubscription } from '../../models/direct-subscription.interface';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';

@Component({
  standalone: false,
  templateUrl: './direct-subscription.component.html',
  styleUrls: ['./direct-subscription.component.scss'],
})
export class DirectSubscriptionComponent implements OnInit {
  DirectPlan = DirectPlan;
  entitlements$ = this.usersFacade.entitlementForFeature$(EntitlementEnum.Direct);

  directSubscription$: Observable<DirectSubscription> = this.direct.subscriptionStatus$;
  isCancellingCancellation: boolean;

  dialogOptions = {
    maxWidth: '100vw',
    maxHeight: '100vh',
    height: '100%',
    width: '100%',
    disableClose: true,
    data: {},
  };

  eligibleSwitchPlans: DirectPlan[];
  isOnProfessionalPlan$ = this.billingFacade.isOnProfessionalPlan$;

  constructor(
    private readonly direct: DirectSubscriptionService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private readonly usersFacade: UsersFacade,
    private readonly billingFacade: BillingFacade
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.open === 'activate') {
        this.activate();
      }
    });

    this.direct.getEligibleSwitchPlans().subscribe((res) => {
      this.eligibleSwitchPlans = res;
    });

    this.billingFacade.loadSubscription();
  }

  cancelDirect() {
    this.dialog.open(DialogDirectCancelInterstitialComponent, this.dialogOptions);
  }

  switchPlan(newPlan: DirectPlan) {
    const dialogData = { ...this.dialogOptions, data: { plan: newPlan } };
    this.dialog.open(DialogSwitchPlanInterstitialComponent, dialogData);
  }

  activate() {
    this.dialog.open(DialogSubscribeToDirectComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      disableClose: true,
      data: {},
    });
  }

  keepDirect() {
    this.isCancellingCancellation = true;

    this.direct.dontCancelDirect().subscribe(
      () => {
        this.isCancellingCancellation = false;
      },
      (err) => {
        this.isCancellingCancellation = false;
      }
    );
  }
}
